<agpr-take-over-panel
    #takeOverPanel
    id="curationAgentPanel"
    class="agpr-curationAgentPanel"
    [header]="headingKey"
    subHeader="AutomationAgents.panel.subHeading"
    headerIcon="fa-kit-duotone fa-agpr-ai-generic"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="1030"
    [maxPanelWidth]="1030"
    [fullHeight]="true"
    [footerContext]="headingKey"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="agpr-curationAgentPanel-body">
        <section class="agpr-curationAgentPanel-card agpr-curationAgentPanel-form">
            <agpr-scroll-panel #formScroll id="curationAgentPanel.form.scroll">
                <div class="agpr-curationAgentPanel-scrollContent">
                    <div class="agpr-curationAgentPanel-section">
                        <h3 class="agpr-curationAgentPanel-sectionHeader">
                            <label id="curationAgentPanel_name_label" class="agpr-curationAgentPanel-sectionHeading">
                                {{ 'AutomationAgents.panel.name' | localize }}
                            </label>
                        </h3>
                        <agpr-text-input
                            id="curationAgentPanel_name"
                            [ariaLabelledBy]="'curationAgentPanel_name_label'"
                            placeholder="AutomationAgents.panel.name.placeholder"
                            [maxLength]="nameMaxLength"
                            [(ngModel)]="agent.name"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    </div>

                    <div class="agpr-curationAgentPanel-section">
                        <h3 class="agpr-curationAgentPanel-sectionHeader prompt">
                            <label id="curationAgentPanel_promptLabel" class="agpr-curationAgentPanel-sectionHeading">
                                {{ 'AutomationAgents.panel.prompt' | localize }}
                            </label>
                            <span class="agpr-infoIconStyle fa-regular fa-circle-info" [agprTooltip]="'AutomationAgents.panel.tooltip'"></span>
                        </h3>

                        <div class="agpr-inputGroupRow">
                            <div class="agpr-inputGroupRow-dropdown">
                                <agpr-dropdown
                                    id="curationAgentPanel_prompt"
                                    placeholder="AutomationAgents.panel.prompt.placeholder"
                                    ariaLabelledBy="curationAgentPanel_promptLabel"
                                    [options]="promptOptions"
                                    [bindToValue]="true"
                                    [ngModel]="selectedPromptOption"
                                    (ngModelChange)="promptChanged($event)"
                                ></agpr-dropdown>
                            </div>
                            <div class="agpr-inputGroupRow-buttons">
                                <agpr-button
                                    id="curationAgentPanel_managePrompts"
                                    [style]="buttonTypes.block"
                                    icon="fa-regular fa-duotone fa-gear"
                                    tooltip="AutomationAgents.panel.prompt.manage"
                                    tooltipPosition="top"
                                    [ariaLabel]="'AutomationAgents.panel.prompt.manage' | localize"
                                    (click)="openPromptManager()"
                                ></agpr-button>
                            </div>
                        </div>

                        @if (creatingPrompt) {
                            <div class="agpr-curationAgentPanel-newPrompt">
                                <agpr-text-input
                                    class="agpr-curationAgentPanel-newPromptName"
                                    id="curationAgentPanel_newPromptName"
                                    label="AutomationAgents.panel.prompt.name"
                                    placeholder="AutomationAgents.panel.prompt.name.placeholder"
                                    [maxLength]="nameMaxLength"
                                    [(ngModel)]="newPromptName"
                                    [bottomMargin]="false"
                                ></agpr-text-input>
                                <agpr-textarea-input
                                    id="curationAgentPanel_newPromptInstructions"
                                    label="AutomationAgents.panel.prompt.instructions"
                                    placeholder="AutomationAgents.panel.prompt.instructions.placeholder"
                                    [rows]="5"
                                    [(ngModel)]="newPromptInstructions"
                                    [bottomMargin]="false"
                                    [hint]="'AutomationAgents.panel.prompt.instructions.hint'"
                                    (focus)="showHelp = true;"
                                ></agpr-textarea-input>
                                <div class="agpr-curationAgentPanel-savePrompt">

                                    <agpr-button
                                        id="curationAgentPanel_savePrompt"
                                        [style]="buttonTypes.tertiary"
                                        label="AutomationAgents.panel.prompt.save"
                                        [disabled]="!canSavePrompt"
                                        [loading]="savingPrompt"
                                        (click)="savePrompt()"
                                    ></agpr-button>
                                </div>
                            </div>
                        } @else if (selectedPromptText) {
                            <div class="agpr-curationAgentPanel-promptText agpr-contextMenu-parent">
                                {{ selectedPromptText }}
                            </div>
                        }
                    </div>

                    <div class="agpr-curationAgentPanel-section">
                        <div class="agpr-curationAgentPanel-sectionHeader">
                            <h3 class="agpr-curationAgentPanel-sectionHeading">{{ 'AutomationAgents.panel.sources' | localize }}</h3>
                            <agpr-button
                                id="curationAgentPanel_addSource"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-duotone fa-square-plus"
                                tooltip="AutomationAgents.panel.sources.add"
                                tooltipPosition="left"
                                [ariaLabel]="'AutomationAgents.panel.sources.add' | localize"
                                [disabled]="!agent.canAddSource"
                                (click)="addSource()"
                            ></agpr-button>
                        </div>

                        @for (source of agent.sources; track source; let index = $index) {
                            <agpr-curation-agent-source-row
                                [id]="'curationAgentPanel.source.' + index"
                                [source]="source"
                                [position]="index + 1"
                                [canRemove]="agent.sources.length > 1"
                                [agentId]="agent.id"
                                (removed)="removeSource($event)"
                            ></agpr-curation-agent-source-row>
                        }
                    </div>
                </div>
            </agpr-scroll-panel>
        </section>

        <section
            class="agpr-curationAgentPanel-card agpr-curationAgentPanel-actions"
            [ngClass]="{'agpr-curationAgentPanel-card-help': showHelp}"
        >
            <agpr-scroll-panel #actionsScroll id="curationAgentPanel.actions.scroll">
                <div class="agpr-curationAgentPanel-scrollContent">
                    @if (showHelp) {
                        <div class="agpr-curationAgentPanel-sectionHeader">
                            <h3 class="agpr-curationAgentPanel-sectionHeading">
                                <span class="agpr-i-light-bulb"></span>
                                {{'AutomationAgents.panel.prompt.help.heading' | localize}}
                            </h3>
                            <agpr-button
                                [id]="'curationAgentPanel_closeHelp'"
                                class="agpr-curationAgentPanel-helpClose"
                                [style]="buttonTypes.icon"
                                [icon]="'fa-solid fa-xmark'"
                                [tooltip]="'AutomationAgents.panel.prompt.help.close'"
                                tooltipPosition="left"
                                (click)="showHelp = false;"
                            ></agpr-button>
                        </div>

                        <ul class="agpr-curationAgentPanel-helpList">
                            <li [innerHtml]="'AutomationAgents.panel.prompt.help.tip1' | localize"></li>
                            <li [innerHtml]="'AutomationAgents.panel.prompt.help.tip2' | localize"></li>
                            <li [innerHtml]="'AutomationAgents.panel.prompt.help.tip3' | localize"></li>
                        </ul>

                        <h4 class="agpr-curationAgentPanel-subheading">{{'AutomationAgents.panel.prompt.help.examples' | localize}}</h4>
                        <ul class="agpr-curationAgentPanel-exampleList">
                            <li>
                                <div class="agpr-curationAgentPanel-exampleLabel">
                                    {{'AutomationAgents.panel.prompt.help.example1' | localize}}
                                </div>
                                <div class="agpr-curationAgentPanel-exampleText">
                                    {{'AutomationAgents.panel.prompt.help.example1.text' | localize}}
                                </div>
                            </li>
                            <li>
                                <div class="agpr-curationAgentPanel-exampleLabel">
                                    {{'AutomationAgents.panel.prompt.help.example2' | localize}}
                                </div>
                                <div class="agpr-curationAgentPanel-exampleText">
                                    {{'AutomationAgents.panel.prompt.help.example2.text' | localize}}
                                </div>
                            </li>
                            <li>
                                <div class="agpr-curationAgentPanel-exampleLabel">
                                    {{'AutomationAgents.panel.prompt.help.example3' | localize}}
                                </div>
                                <div class="agpr-curationAgentPanel-exampleText">
                                    {{'AutomationAgents.panel.prompt.help.example3.text' | localize}}
                                </div>
                            </li>
                            <li>
                                <div class="agpr-curationAgentPanel-exampleLabel">
                                    {{'AutomationAgents.panel.prompt.help.example4' | localize}}
                                </div>
                                <div class="agpr-curationAgentPanel-exampleText">
                                    {{'AutomationAgents.panel.prompt.help.example4.text' | localize}}
                                </div>
                            </li>
                        </ul>


                    } @else {
                        <agpr-curation-agent-actions
                            id="curationAgentPanel.actions"
                            [positiveActions]="agent.positiveActions"
                            [negativeActions]="agent.negativeActions"
                            [overlayContainer]="overlayContainer"
                            (actionsChanged)="actionsChanged($event)"
                            (addCardOpened)="scrollActionsToEnd()"
                        ></agpr-curation-agent-actions>
                    }

                </div>
            </agpr-scroll-panel>
        </section>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            id="curationAgentPanel.cancel"
            [style]="buttonTypes.secondary"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            id="curationAgentPanel.save"
            [style]="buttonTypes.primary"
            [label]="saveLabel"
            [disabled]="!canSave"
            [loading]="saving"
            (click)="save()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
